/**
 * Theme color enumeration for Medante components
 */
export enum THEME_COLORS_ENUM {
  PINK = 'pink',
  WHITE = 'white',
  SAND = 'sand',
  TIRQUOISE = 'tirquoise',
  BLUE = 'blue',
  FUCHSIA = 'fuchsia',
  PURPLE = 'purple',
  CYCLAMEN = 'cyclamen',
}
